import React from 'react';

const NotFound = () => (
  <div>
    Sorry no content found
  </div>
);

export default NotFound;
